<template>
  <div class="chart">
    {{chartOptions.time.timezone}}
    <highcharts id="mainChart" :options="chartOptions" :updateArgs="updateArgs" ref="myChart"></highcharts>

    <ZoneDialog :id="levelDetailId" @clearDetail="clearDetail" />
  </div>
</template>

<script>
var moment = require("moment-timezone");
import axios from "axios";
import { mapGetters } from "vuex";
import ZoneDialog from "@/components/zoneDialog";

export default {
  components: { ZoneDialog },
  props: [
    "chartData",
    "newData",
    "lastClose",
    "fills",
    "tradeType",
    "zones",
    "timeframe"
  ],
  data() {
    return {
      changeZone: 0,
      loaded: false,
      levelDetailId: null,
      /* chartFrom: moment()
        .startOf("day")
        .toString(),
      chartTo: moment()
        .endOf("day")
        .toString(), */
      updateTradeMarkers: 0,
      exitLines: [],
      zoneRefresh: 0,
      chartFrom: 0,
      chartTo: 0,
      moment: moment,
      updateArgs: [true, true, { duration: 300 }],
      chartOptions: {
        chart: {
          backgroundColor: "#28303D",
          marginRight: 50,
          height: 370,
          type: "line"
        },
        time: {
          timezoneOffset: 6 * 60
        },
        title: {
          text: ""
        },
        xAxis: [
          {
            //startOnTick: true,
            //endOnTick: true,
            margin: 0,
            lineWidth: 0,
            //ordinal: true,
            minorGridLineWidth: 0,
            lineColor: "transparent",
            minorTickLength: 0,
            tickLength: 0,
            //tickInterval: 24 * 3600 * 1000,
            gridLineWidth: 1,
            gridLineColor: "rgba(128, 143, 156, 0.1)",
            type: "datetime",
            labels: {
              align: "left",
              x: -10,
              style: {
                color: "#808F9C",
                fontSize: "10px",
                fontFamily: "Roboto, sans-serif"
              }
            },
            crosshair: {
              zIndex: 30,
              width: 1,
              dashStyle: "dash",
              color: "rgba(128, 143, 156, 0.3)",
              snap: false,
              label: {
                enabled: true,
                padding: 3,
                format: "{value:%H:%M:%S}",
                style: {
                  color: "white",
                  fontSize: "12px",
                  fontFamily: "Roboto, sans-serif"
                }
              }
            }
          }
        ],
        yAxis: [
          {
            min: 0,
            max: 0,
            plotBands: [],
            title: "",
            gridLineWidth: 0,
            opposite: true,
            resize: {
              enabled: false
            },
            crosshair: {
              zIndex: 30,
              width: 1,
              dashStyle: "dash",
              color: "rgba(128, 143, 156, 0.3)",
              snap: false,
              label: {
                adjustToOffset: true, // New param
                enabled: true,
                padding: 3,
                offset: -60,
                zIndex: 30,
                formatter: function(value) {
                  return (Math.ceil(value / 0.25) * 0.25).toFixed(2);
                },
                style: {
                  color: "white",
                  fontSize: "12px",
                  fontFamily: "Roboto, sans-serif",
                  zIndex: 30
                }
              }
            },
            offset: 100,
            labels: {
              distance: 0,
              align: "left",
              format: "{value:.2f}",
              style: {
                color: "#808F9C",
                fontSize: "10px",
                fontFamily: "Roboto, sans-serif"
              },
              y: 6,
              x: 18
            }
          }
        ],
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              style: {
                fontWeight: "bold",
                color: "#ffffff",
                textOutline: 0
              },
              formatter: function() {
                return null;
              }
            },
            animations: false
            //cursor: 'pointer',
          },
          flags: {
            fillColor: "transparent",
            color: "transparent",
            //y: -9,
            //x: 4000000,
            //yAxis: 50,
            style: { fontSize: "11px", color: "white" }
          },
          line: {
            color: "#808F9C",
            marker: {
              enabled: false
            }
          },
          ohlc: {
            color: "#808F9C",
            lineWidth: 1
          },
          scatter: {
            color: "#ffffff",
            //lineWidth: 20,
            marker: {
              radius: 4,
              symbol: "circle"
            }
          },
          column: {
            dataGrouping: {
              enabled: false
            }
          },
          bubble: {
            tooltip: {
              shared: false,
              pointFormat:
                '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
              //'{point.y}'
            },
            minSize: 15,
            maxSize: 15,

            dataLabels: {
              inside: true,
              enabled: true,
              format: "{point.z}"
            }
            //cursor: "pointer"
          }
        },
        tooltip: {
          enabled: false,
          backgroundColor: "#28303D",
          style: {
            fontFamily: "Roboto, sans-serif",
            color: "#808F9C",
            fontSize: "11px",
            fontWeight: "light"
          },
          shape: "square",
          headerShape: "callout",
          borderWidth: 0,
          shadow: false,
          positioner: function(width, height, point) {
            var chart = this.chart,
              position;
            if (point.isHeader) {
              position = {
                x: Math.max(
                  // Left side limit
                  chart.plotLeft,
                  Math.min(
                    point.plotX + chart.plotLeft - width / 2,
                    // Right side limit
                    chart.chartWidth - width - chart.marginRight
                  )
                ),
                y: point.plotY
              };
            } else {
              position = {
                x: point.series.chart.plotLeft,
                y: point.series.yAxis.top - chart.plotTop
              };
            }
            return position;
          },
          formatter: function() {
            return (
              "<b>" +
              "Date: " +
              moment(new Date(this.x)).format("H:mm:ss") +
              " O: " +
              this.y.toFixed(2) +
              " H: " +
              this.y.toFixed(2)
            );
          }
        },
        credits: { enabled: false },
        legend: { enabled: false },
        series: [
          {
            animation: true,
            enableMouseTracking: false,
            //data: this.$store.state.highchartsData,
            data: [],
            type: "line",
            zIndex: 2
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "scatter",
            zIndex: 2
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "flags",
            zIndex: 2
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "scatter",
            color: "#28303D",
            marker: {
              radius: 1,
              symbol: "circle"
            }
          },
          {
            type: "bubble",
            animation: false,
            enableMouseTracking: true,
            data: [],
            cursor: "pointer",
            boostBlending: "alpha",
            turboThreshold: 0,
            boostThreshold: 1,
            zIndex: 2,
            marker: {
              fillOpacity: 0.8
            },
            point: {
              events: {
                mouseover: function() {
                  document.getElementById("mainChart").style.cursor = "pointer";
                },
                mouseout: function() {
                  document.getElementById("mainChart").style.cursor =
                    "crosshair";
                },
                click: function() {
                  //window.open('/trades/'+this.name+'/'+this.x+'/'+ this.point,"_self");
                }
              }
            }
          },
          {
            type: "bubble",
            animation: false,
            enableMouseTracking: false,
            data: [],
            boostBlending: "alpha",
            turboThreshold: 0,
            boostThreshold: 1,
            minSize: 5,
            maxSize: 5,
            zIndex: 4,
            //color: "#E62163"
            marker: {
              fillOpacity: 1
            }

            //color: "#E62163"

            /*
            marker: {
              radius: 10,
              symbol: "circle"
            },
            color: "#E62163",
            */
          }
          /*
          {
            name: 'Zones',
            animation: false,
            enableMouseTracking: true,
            borderColor: 'gray',
            data: [],
            type: "xrange",
            opacity: 0.3
          },
          */
        ]
      }
    };
  },

  methods: {
    clearDetail() {
      this.levelDetailId = null;
    },
    updateFills() {
      this.chartOptions.series.length = 6;

      var colorRed = "#E62163";
      var colorGreen = "#79C04D";
      var entryData = [];
      var exitData = [];
      this.Trades.forEach(trade => {
        if (trade.openTimestamp >= this.chartFrom) {
          var entryDataTrade = [];

          var typeColor = colorRed;
          if (trade.TradeType == 1) {
            typeColor = colorGreen;
          }

          trade.Fills.forEach(element => {
            if (
              (trade.TradeType > 0 && element.volume > 0) ||
              (trade.TradeType < 0 && element.volume < 0)
            ) {
              if (element.time >= this.chartFrom) {
                entryData.push({
                  x: parseInt(element.time),
                  y: parseFloat(element.price),
                  z: parseInt(Math.abs(element.volume)),
                  dataLabels: { inside: true, className: "roboto" },
                  color: typeColor

                  //fillColor : "#79C04D"
                });
              }
              entryDataTrade.push({
                time: parseInt(element.time),
                price: parseFloat(element.price),
                volume: parseFloat(element.volume)
              });
            } else {
              if (element.time >= this.chartFrom) {
                var exitPL = 0;
                while (element.volume != 0) {
                  var exitColor = colorRed;
                  if (
                    trade.TradeType > 0 &&
                    element.price > entryDataTrade[0].price
                  ) {
                    exitColor = colorGreen;
                  } else if (
                    trade.TradeType < 0 &&
                    element.price < entryDataTrade[0].price
                  ) {
                    exitColor = colorGreen;
                  }

                  //alert(element.time + " + " + element.price)
                  //alert(entryDataTrade[0].time + " + " + entryDataTrade[0].price)
                  this.chartOptions.series[this.chartOptions.series.length] = {
                    zIndex: 1,
                    animation: false,
                    enableMouseTracking: false,
                    data: [
                      [entryDataTrade[0].time, entryDataTrade[0].price],
                      [element.time, element.price]
                    ],
                    dashStyle: "Dot",
                    lineWidth: 1,
                    type: "line",
                    color: exitColor
                  };
                  //alert("added")
                  var absOpenVol = Math.abs(entryDataTrade[0].volume);
                  var absCloseVol = Math.abs(element.volume);
                  if (absOpenVol == absCloseVol) {
                    exitPL += Math.abs(
                      (element.price - entryDataTrade[0].price) * element.volume
                    );
                    exitData.push({
                      x: parseInt(element.time),
                      y: parseFloat(element.price),
                      z: exitPL.toFixed(2),
                      dataLabels: {
                        color: exitColor,
                        inside: false,
                        y: -10,
                        x: 12,
                        className: "roboto"
                      },
                      color: exitColor
                      //fillColor : "#79C04D"
                    });
                    entryDataTrade.shift();
                    //entryDataTrade=entryDataTrade.slice(1)
                    break;
                  } else if (absOpenVol > absCloseVol) {
                    //alert("toto2")
                    exitPL += Math.abs(
                      (element.price - entryDataTrade[0].price) * element.volume
                    );
                    entryDataTrade[0].volume += element.volume;
                    exitData.push({
                      x: parseInt(element.time),
                      y: parseFloat(element.price),
                      z: exitPL.toFixed(2),
                      dataLabels: {
                        color: exitColor,
                        inside: false,
                        y: -10,
                        x: 12,
                        className: "roboto"
                      },
                      color: exitColor
                      //fillColor : "#79C04D"
                    });
                    break;
                  } else if (absOpenVol < absCloseVol) {
                    //alert("toto3")
                    exitPL += Math.abs(
                      (element.price - entryDataTrade[0].price) *
                        entryDataTrade[0].volume
                    );
                    element.volume += entryDataTrade[0].volume;
                    entryDataTrade.shift();
                    //entryDataTrade=entryDataTrade.slice(1)
                  }
                }
              }
            }
          });
        }
      });

      this.zonesData();
      //data.reverse();

      //this.$store.dispatch("ADD_DATA", socketData)
      this.chartOptions.series[4].data = [];
      this.chartOptions.series[5].data = [];
      this.chartOptions.series[4].data = entryData;
      this.chartOptions.series[5].data = exitData;

      this.$emit("switch", false);
    },
    /*
    addFill(data) {
      var colorRed = "#E62163";
      var colorGreen = "#79C04D";
      var bubbleColor = colorRed;

      if (data.volume > 0) {
        bubbleColor = colorGreen;
      } else {
        bubbleColor = colorRed;
      }

      if (
        (data.tradeType < 0 && data.fill.volume < 0) ||
        (data.tradeType > 0 && data.fill.volume > 0)
      ) {
        this.chartOptions.series[4].data.push({
          x: parseInt(data.fill.time),
          y: parseFloat(data.fill.price),
          z: parseInt(Math.abs(data.fill.volume)),
          color: bubbleColor
          //fillColor : "#79C04D"
        });
      } else {
        this.chartOptions.series[5].data.push({
          x: parseInt(data.fill.time),
          y: parseFloat(data.fill.price),
          color: bubbleColor
          //fillColor : "#79C04D"
        });
      }
    },
    */
    updateClose(data) {
      this.chartOptions.series[0].data[
        this.chartOptions.series[0].data.length - 1
      ] = [parseInt(data[1]), parseFloat(data[2])];

      if (data[2] > this.chartOptions.yAxis[0].max)
        this.chartOptions.yAxis[0].max = data[2];
      if (data[2] < this.chartOptions.yAxis[0].min)
        this.chartOptions.yAxis[0].min = data[2];

      this.chartOptions.series[2].data = [
        {
          x: data[1],
          y: parseFloat(data[2]),
          title: parseFloat(data[2])
            .toFixed(2)
            .toString()
        }
      ];
      this.chartOptions.series[3].data = [
        {
          x: parseInt(data[1] + 200000),
          y: parseFloat(data[2])
        }
      ];
      this.chartOptions.series[1].data = [
        {
          x: parseInt(data[1]),
          y: parseFloat(data[2])
        }
      ];
    },

    updateData(data) {
      switch (this.timeframe) {
        case 600:
          this.chartOptions.xAxis[0].tickInterval = 24 * 3600 * 1000;
          break;
        case 300:
          this.chartOptions.xAxis[0].tickInterval = 12 * 3600 * 1000;
          break;
        case 180:
          this.chartOptions.xAxis[0].tickInterval = 6 * 3600 * 1000;
          break;
        case 60:
          this.chartOptions.xAxis[0].tickInterval = 1 * 3600 * 1000;
          break;
        case 30:
          this.chartOptions.xAxis[0].tickInterval = 0.5 * 3600 * 1000;
          break;
        case 5:
          this.chartOptions.xAxis[0].tickInterval = 0.5 * 3600 * 1000;
          break;
        default:
        // code block
      }

      var chartData = [];
      this.chartOptions.series[0].data = [];
      this.chartOptions.series[1].data = [];
      this.chartOptions.series[2].data = [];
      this.chartOptions.series[3].data = [];

      // chart Y min max
      var chartMin = 9999999999999;
      var chartMax = -9999999999999;

      data.forEach(bar => {
        if (bar.time > 0) chartData.push([bar.time * 1000, bar.close]);

        if (bar.low < chartMin) chartMin = bar.low;
        if (bar.high > chartMax) chartMax = bar.high;
      });

      var interval = Math.abs(chartMax - chartMin);

      this.chartOptions.yAxis[0].max = chartMax + 0.15 * interval;
      this.chartOptions.yAxis[0].min = chartMin - +0.15 * interval;

      //chartData = chartData.reverse()
      this.chartOptions.series[0].data = chartData;
      this.chartOptions.series[2].data = [
        {
          x: chartData[chartData.length - 1][0] + 3000,
          y: chartData[chartData.length - 1][1],
          title: chartData[chartData.length - 1][1].toString()
        }
      ];
      this.chartOptions.series[3].data = [
        {
          x: chartData[chartData.length - 1][0] + 200000,
          y: chartData[chartData.length - 1][1]
        }
      ];
      this.chartOptions.series[1].data = [
        {
          x: chartData[chartData.length - 1][0],
          y: chartData[chartData.length - 1][1]
        }
      ];
    },
    addBar(data) {
      this.chartOptions.series[0].data.push([data[1] * 1000, data[2]]);
      this.zonesData();
    },
    zonesData() {
      this.chartOptions.series = this.chartOptions.series.filter(
        item => !(item.type == "polygon" || item.name == "zoneflag")
      );

      //const { chart } = this.$refs.myChart;
      let vm = this;
      this.chartOptions.yAxis[0].plotBands = [];
      var colors = {
        Long: "rgba(0,255,0,0.3)",
        Short: "rgba(255,0,0,0.3)",
        Neutral: "rgba(0,0,0,0.1)"
      };

      //this.chartOptions.series[6].data = []

      this.Levels.forEach(zone => {
        /*
        let distX = chart.xAxis[0].toPixels(Date.parse(zone.createdAt));
        let distY = chart.yAxis[0].toPixels(zone.high);
        let distYY = chart.yAxis[0].toPixels(zone.low);
        let timeEnd = 2222222222222
        let width = Math.abs(distY-distYY)
      
      var myRect = chart.renderer.rect(distX, distY, timeEnd, width, 0)

      
        myRect.attr({
          "stroke-width": 0,
          stroke: "red",
          fill: colors[zone.type],
          zIndex: 3,
          opacity: 1
        })
        myRect.destroy();
       // myRect.add();

        myRect = chart.renderer.rect(distX, distY, timeEnd, width, 0)

      
        myRect.attr({
          "stroke-width": 0,
          stroke: "red",
          fill: colors[zone.type],
          zIndex: 3,
          opacity: 1
        })
        //myRect.destroy();
        myRect.add();
        */

        /*
       var zoneStart = new Date(zone.createdAt).getTime()
       //alert(zoneStart+" "+ this.chartFrom)
        if(zoneStart < this.chartFrom){
            zoneStart = this.chartFrom
        }

      var zoneEnd = new Date().getTime()
    

       var xrange = {
         color:"red",
        pointWidth: 2,
        x:  zoneStart,
        x2: zoneEnd,
        y: zone.high,
       }

       this.chartOptions.series[6].data.push(xrange);
       */

        if (zone.low > 0 && zone.high > 0) {
          var zoneStart = new Date(zone.createdAt).getTime();

          if (zoneStart < this.chartFrom) {
            zoneStart = this.chartFrom;
          }

          var zoneEnd = this.chartTo;
          if (zone.deleted) {
            zoneEnd = new Date(zone.deletedDate).getTime();
          }

          if (zoneEnd > this.chartFrom) {
            var polygonData = [
              [zoneStart - 12 * 60 * 1000, parseFloat(zone.low)],
              [zoneEnd, parseFloat(zone.low)],
              [zoneEnd, parseFloat(zone.high)],
              [zoneStart - 12 * 60 * 1000, parseFloat(zone.high)]
            ];

            var seriesData = {
              dataLabels: { className: "roboto" },
              cursor: "pointer",
              data: polygonData,
              type: "polygon",
              zIndex: 1,
              color: colors[zone.type],
              point: {
                events: {
                  click() {
                    vm.levelDetailId = null;
                    vm.levelDetailId = zone._id;
                  }
                }
              }
            };
            this.chartOptions.series.push(seriesData);

            var flagData = {
              name: "zoneflag",
              cursor: "pointer",
              animation: false,
              dataLabels: { borderWidth: 1 },
              enableMouseTracking: true,
              style: { fontSize: "6px", color: "grey" },
              y: -10,
              data: [
                {
                  x: zoneStart - 12 * 60 * 1000,
                  y: zone.low,
                  title: zone._creator.username + ": " + zone.name
                }
              ],
              type: "flags",
              point: {
                events: {
                  click() {
                    vm.levelDetailId = null;
                    vm.levelDetailId = zone._id;
                  }
                }
              }
            };

            this.chartOptions.series.push(flagData);
          }
        }

        /*

        var data = {
          color: colors[zone.type],
          from: zone.low,
          to: zone.high,
          zIndex: 2,
          label: {
            text: zone._creator.username + ": " + zone.name,
            style: {
              allowPointSelect: true,
              //cursor : 'pointer',
              color: "#808F9C",
              fontSize: "10px",
              zIndex: 1
              //fontWeight: 'bold'
            }
          },
          events: {
            mouseover: function() {
              document.getElementById("mainChart").style.cursor = "pointer";
            },
            mouseout: function() {
              document.getElementById("mainChart").style.cursor = "crosshair";
            },
            click: function() {
              vm.levelDetailId = null;
              vm.levelDetailId = zone._id;
            }
          }
        };
        */

        //this.chartOptions.yAxis[0].plotBands.push(data);
      });
      //this.$refs.myChart.reflow();
    },
    klik() {
      alert("aaaa");
    }
  },
  mounted() {
    var offset = moment.tz(this.timezone).utcOffset()
    this.chartOptions.time.timezoneOffset = offset * -1
  },
  sockets: {
    MARKET: function(data) {
      if (data[0] == this.activeChart.pool) this.updateClose(data);
    },
    NEWBAR: function(data) {
      if (data[0] == this.activeChart.pool + "_" + this.timeframe)
        this.addBar(data);
    },

    TIMELINE: function(data) {
      if (data.action == "add") {
        if (data.type == "New Zone" || data.type == "Deleted Zone") {
          this.zoneRefresh++;
        }
      }
      if (data.action == "update") {
        if (data.data.Change) {
          if (data.data.Symbol.pool == this.activeChart.pool) {
            this.Trades.forEach((trade, index) => {
              if (trade.openTimestamp == data.data.openTimestamp) {
                this.Trades[index].Fills = data.data.Fills;
              }
            });
            this.updateFills();
            //this.updateTradeMarkers++

            /*
            this.addFill({
              fill: data.data.Fills[data.data.Fills.length - 1],
              tradeType: data.data.TradeType
            });
            */
          }
        }
      }
      if (data.action == "add") {
        if (data.type == "Trade Open") {
          if (data.data.Symbol.pool == this.activeChart.pool) {
            if (!data.data.hasOwnProperty("Fills"))
              data.data.Fills = [
                {
                  time: data.data.openTimestamp,
                  price: data.data.AverageEntryPrice,
                  volume: data.data.Quantity
                }
              ];
            this.Trades.push(data.data);
            //this.updateFills()
            //this.updateTradeMarkers++
            /*
            let fillData = {
              time: data.data.openTimestamp,
              price: data.data.AverageEntryPrice,
              volume: data.data.EntryQuantity * data.data.TradeType
            };
            this.addFill({ fill: fillData, tradeType: data.data.TradeType });
            */
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(["markets", "userSubmenus", "settings", "timezone"]),

    activeChart() {
      if (this.userSubmenus["Section0"].items.length > 0) {
        var menuIdx = this.userSubmenus["Section0"].selected;
        return this.userSubmenus["Section0"].items[menuIdx];
      } else return { pool: null };
    }
  },

  asyncComputed: {
    Levels: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/levels/", {
              method: "all",
              ticker: this.activeChart.pool
            })
            .then(response => {
              resolve(response.data);
              //alert("zones")
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: [],
      watch: ["Data", "zoneRefresh"]
    },
    Trades: {
      get() {
        //alert(this.chartFrom)
        this.$emit("switch", true);
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/trades/", {
              method: "chart",
              symbol: this.activeChart.pool,
              dataFrom: this.chartFrom,
              dataTo: this.chartTo
            })
            .then(response => {
              resolve(response.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: [],
      watch: ["Data"]
    },
    Data: {
      get() {
        if (this.activeChart) {
          return new Promise((resolve, reject) => {
            axios
              .post("https://tradeinpool.com:3006/request/data/", {
                ticker: this.activeChart.pool,
                timeframe: this.timeframe
              })
              .then(response => {
                this.chartFrom = response.data[0].time * 1000;
                this.chartTo =
                  response.data[response.data.length - 1].time * 1000 +
                  15 * 60 * 1000;
                resolve(response.data);
                //resolve([]);
              })
              .catch(err => {
                reject(err);
              });
          });
        }
      },
      default: [],
      watch: ["activeChart", "timeframe"]
    }
  },

  watch: {
    timezone(val) {
      var offset = moment.tz(val).utcOffset()
      this.chartOptions.time.timezoneOffset = offset * -1
    },
    Trades() {
      this.updateFills();
    },
    Data(data) {
      this.updateData(data);
      //this.zonesData();
    },
    Levels() {
      this.zonesData();
    }
  }
};
</script>

<style scoped>
.chart {
  float: left;
  width: 100%;
  padding: 5px 0px 5px 5px;
  cursor: crosshair;
}
</style>


